import {
  Download,
  Users,
  Store,
  Briefcase,
  TrendingUp,
  Sparkles,
  Megaphone,
  Mail,
} from "lucide-react";

import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";

export function LiveStats() {
  const stats = [
  { icon: Download, n: "2,500+", l: "App Downloads" },
  { icon: Users, n: "1,000+", l: "Registered Users" },
  { icon: Store, n: "400+", l: "Verified Shops & Services" },
  { icon: Briefcase, n: "800+", l: "Jobs & Local Tasks Posted" },
];
  return (
    <section className="py-16 md:py-20 bg-[#1A1918] text-white">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-2 justify-center text-[#FF5A00] text-sm font-semibold">
          <TrendingUp className="w-4 h-4" /> Live Platform Statistics
        </div>
        <h2 className="mt-3 text-center text-3xl md:text-4xl font-bold">Growing one city at a time.</h2>
        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map(({ icon: Icon, n, l }) => (
            <div key={l} className="text-center rounded-3xl bg-white/5 border border-white/10 p-6">
              <Icon className="w-7 h-7 text-[#FF5A00] mx-auto" />
              <div className="mt-3 text-3xl md:text-4xl font-extrabold">{n}</div>
              <div className="mt-1 text-sm text-white/60">{l}</div>
            </div>
          ))}
        </div>
        {/* <p className="mt-6 text-center text-xs text-white/40 italic">* Illustrative figures — live counters coming soon.</p> */}
      </div>
    </section>
  );
}

export function CommunityImpact() {
  const items = [
    { t: "Neighbours helping neighbours", d: "From urgent plumbing to weekend tutoring — real people, real help, same street." },
    { t: "Small businesses, big reach", d: "Local kirana stores and service pros get discovered by customers nearby, commission-free." },
    { t: "Safety as a community", d: "Blood requests and SOS alerts mobilise your trusted circle when it matters most." },
  ];
  return (
    <section className="py-20 md:py-28">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div className="relative">
            <div className="absolute -inset-4 bg-[#FF5A00]/10 rounded-[2rem] -rotate-2" />
            <img
              src="/Media-Library/h2.png"
              alt="Community using Time2Cash"
              className="relative rounded-[2rem] w-full aspect-[4/3] object-cover shadow-xl"
            />
          </div>
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-[#FFF3ED] text-[#FF5A00] px-4 py-1.5 text-xs font-semibold">
              Community Impact
            </div>
            <h2 className="mt-4 text-4xl md:text-5xl font-bold text-[#1A1918] leading-tight">
              More than an app — <span className="brand-gradient-text">a local movement.</span>
            </h2>
            <div className="mt-8 space-y-5">
              {items.map((it) => (
                <div key={it.t} className="flex gap-4">
                  <div className="w-10 h-10 rounded-full bg-[#FFF3ED] flex items-center justify-center flex-shrink-0">
                    <Sparkles className="w-5 h-5 text-[#FF5A00]" />
                  </div>
                  <div>
                    <div className="font-bold text-[#1A1918]">{it.t}</div>
                    <div className="text-[#4A4846] text-sm mt-1 leading-relaxed">{it.d}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function Announcements() {
  const posts = [
  {
    tag: "Launch",
    date: "August 2026",
    t: "Time2Cash Official App Launch",
    d: "The official Time2Cash app is launching this August with local tasks, jobs, marketplace, shops, and more."
  },
  {
    tag: "Expansion",
    date: "Coming Soon",
    t: "Kurnool City Expansion",
    d: "After Anantapur, Time2Cash is expanding to Kurnool. Stay tuned as we bring our local community platform to another city."
  },
  {
    tag: "Coming Soon",
    date: "2027",
    t: "SOS Emergency Safety Feature",
    d: "Our Emergency SOS feature will launch in 2027, helping users instantly share their live location with trusted contacts during emergencies."
  },
];
  return (
    <section className="py-20 md:py-28 bg-[#FFF9F5]">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between flex-wrap gap-4">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-white border border-[#EBE8E3] px-4 py-1.5 text-xs font-semibold text-[#4A4846]">
              <Megaphone className="w-3.5 h-3.5 text-[#FF5A00]" /> Latest Announcements
            </div>
            <h2 className="mt-4 text-4xl md:text-5xl font-bold text-[#1A1918] leading-tight">What&apos;s new at Time2Cash.</h2>
          </div>
          <Link to="/blog" className="text-[#FF5A00] font-semibold hover:gap-3 inline-flex items-center gap-2 transition-all">
            View all updates <span>→</span>
          </Link>
        </div>
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {posts.map((p) => (
            <Link key={p.t} to="/blog" className="rounded-3xl bg-white border border-[#EBE8E3] p-6 hover:shadow-lg hover:-translate-y-1 transition-all">
              <div className="flex items-center justify-between">
                <span className="rounded-full bg-[#FFF3ED] text-[#FF5A00] px-3 py-1 text-xs font-semibold">{p.tag}</span>
                <span className="text-xs text-[#78716C]">{p.date}</span>
              </div>
              <h3 className="mt-4 text-lg font-bold text-[#1A1918]">{p.t}</h3>
              <p className="mt-2 text-sm text-[#4A4846] leading-relaxed">{p.d}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export function Newsletter() {
  const [email, setEmail] = useState("");
  const onSubmit = (e) => {
    e.preventDefault();
    toast.success("You're subscribed! Watch your inbox for local updates.");
    setEmail("");
  };
  return (
    <section className="py-20">
      <div className="container mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-[2rem] border border-[#EBE8E3] bg-white p-8 md:p-12 text-center">
          <div className="w-12 h-12 rounded-2xl bg-[#FFF3ED] flex items-center justify-center mx-auto">
            <Mail className="w-6 h-6 text-[#FF5A00]" />
          </div>
          <h2 className="mt-4 text-3xl md:text-4xl font-bold text-[#1A1918]">Stay updated.</h2>
          <p className="mt-3 text-[#4A4846]">Get city launches, feature drops, and community stories in your inbox.</p>
          <form onSubmit={onSubmit} data-testid="newsletter-form" className="mt-6 flex flex-col sm:flex-row gap-3 max-w-lg mx-auto">
            <input
              type="email"
              required
              data-testid="newsletter-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              className="flex-1 rounded-full border border-[#EBE8E3] bg-[#FDFBF7] px-5 py-3.5 text-sm outline-none focus:border-[#FF5A00]"
            />
            <button
              type="submit"
              data-testid="newsletter-submit"
              className="rounded-full bg-[#FF5A00] hover:bg-[#E65100] text-white px-7 py-3.5 font-semibold transition-colors"
            >
              Subscribe
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
